import LinkedAccountConfigurationCard from "./LinkedAccountConfigurationCard";

export default LinkedAccountConfigurationCard;
